const zhCN = {
  'INTEGRATIONS.ServiceNow.discovery.CONNECTIONNAME.title': '发现源名称',
  'INTEGRATIONS.ServiceNow.discovery.USERNAME.title': '用户 ID',
  'INTEGRATIONS.ServiceNow.discovery.INSTANCENAME.title': 'Service Now URL',
  'INTEGRATIONS.ServiceNow.discovery.PASSWORD.title': '密码',
  'INTEGRATIONS.SERVICENOW.URL.VALIDATION_ERROR1': 'URL 无效',
  'INTEGRATIONS.LABEL.DISCOVERY_FREQUENCY': '发现频率',
  'INTEGRATIONS.DESCRIPTION.KBA_PROMPT':
    '提示用户回答基于知识的身份验证 (KBA) 问题。',
  'INTEGRATIONS.DISCOVERY.DESCRIPTION':
    '通过以下常见发现源之一来发现您的应用程序和工作负荷。您将会获得以下好处: 详细信息预填写、建议按优先级排序以及使用状态的完整试图。',
  'INTEGRATIONS.DISCOVERY.BACK': '返回',
  'INTEGRATIONS.DISCOVERY.TITLE': '设置发现',
  'INTEGRATIONS.DISCOVERY.COMINGSOON': '即将推出...',
  'INTEGRATIONS.DISCOVERY.LEARNMORE': '了解详情',
  'INTEGRATIONS.DISCOVERY.CONNECTION.APPLICATION.SETUP.DESCRIPTION':
    '输入应用程序凭据以建立连接。连接成功后，将可以导入数据。',
  'INTEGRATIONS.DISCOVERY.ERROR.HEADING': '加载页面时出现问题。',
  'INTEGRATIONS.DISCOVERY.ERROR.SUBHEADING':
    '尝试刷新或稍后查看。如果问题持续存在，请联系管理员。',
  'INTEGRATIONS.DISCOVERY.ERROR.RELOAD': '重新加载',
  'INTEGRATIONS.ServiceNow.discovery.CONNECTION_SETTINGS.title': '连接设置',
  'INTEGRATIONS.ServiceNow.discovery.CI_CLASSES.title': 'CI 类***',
  'INTEGRATIONS.ServiceNow.discovery.ATTRIBUTE_MAPPING.title': '属性映射',
  'INTEGRATIONS.Feature.Basic.ServiceNow.discovery.Conn.Title': '连接详细信息',
  'INTEGRATIONS.BUTTON.SAVE': '保存',
  'INTEGRATIONS.DISCOVERY.SELECT': '选择',
  'INTEGRATIONS.DISCOVERY.CREATE_NEW_CONNECTION': '创建新连接',
  'INTEGRATIONS.DISCOVERY.USE_THIS_CONNECTION': '使用此连接',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED': 'ServiceNow 已保存!',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.DESCRIPTION':
    '与发现源 ServiceNow 的连接已成功测试且保存。导入数据以完成发现设置。可以跳过...',
  'INTEGRATIONS.DISCOVERY.IMPORT': '导入资产',
  'INTEGRATIONS.DISCOVERY.SKIP_FOR_NOW': '暂时跳过',
  'INTEGRATIONS.DISCOVERY.SERVICENOW.SAVED.INLINE': '导入开始后，将无法取消',
  'INTEGRATION.DISCOVERY.SETUP.GUIDE_ME': '引导我',
  'INTEGRATION.DISCOVERY.SELECT_EXISTING': '选择现有连接',
  'INTEGRATION.DISCOVERY.CONNECTION.NAME': '连接名称',
  'INTEGRATION.EXISTING.CONNECTION.SUBTEXT':
    '我们发现{total, plural, one {一} other {#}}个现有连接配置:',
  'INTEGRATIONS.FILEUPLOAD.STARTIMPORT': '开始导入',
  'INTEGRATIONS.FILEUPLOAD.IMPORTINGDATA': '从 Excel 文件导入数据。请稍后...',
  'INTEGRATIONS.TRY.AGAIN': '请重试',
  'INTEGRATIONS.CLOSE': '关闭',
  'INTEGRATIONS.ERROR.CONNECTION': '连接错误。请重试。',
  'INTEGRATIONS.FILEUPLOAD.SUCCESS':
    '等候时可以退出页面。过程完成后，我们将通知您。',
  'INTEGRATIONS.FILEUPLOAD.MODAL.TITLE': '导入发现源',
  'INTEGRATIONS.FILEUPLOAD.HEADING': '从文件中导入发现源',
  'INTEGRATIONS.FILEUPLOAD.DOWNLOAD_SAMPLE': '下载示例文件',
  'INTEGRATIONS.FILEUPLOAD.INPUT_LABEL': '发现源名称',
  'INTEGRATIONS.FILEUPLOAD.INPUT_PLACEHOLDER': '输入文件名',
  'INTEGRATIONS.FILEUPLOAD.INVALID_NAME':
    '请输入有效的名称。仅允许字母、数字和选定符号',
  'INTEGRATIONS.FILEUPLOAD.UPLOADING': '正在上传...',
  'INTEGRATIONS.FILEUPLOAD.CONTINUE': '继续',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.TITLE':
    '以下从 XLSX 文件上传的前 10 个记录。',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.MISSING_HEADER': '缺少必需标题',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.COLUMN_ERRORS_SUFFIX': '检测到列错误',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.ALERT.FIX_ISSUES':
    '继续数据导入之前请修复问题。',
  'INTEGRATIONS.FILEUPLOAD.PREVIEW.EXCLUDE': '从导入中排除',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.TITLE': '应用程序使用确认',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DESCRIPTION':
    '我们已识别应用程序类型。请确认这是否是要使用的正确应用程序类型。',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.DEFAULT_APP_DESC':
    '要使用的应用程序类型为 {applicationName}',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.SELECT_DIFFERENT':
    '否，从应用程序列表中选择',
  'INTEGRATIONS.DASHBOARD.APPLICATION_ONBOARDING.CONFIRM': '是，我要使用',
  'INTEGRATIONS.DASHBOARD.HEADER.TITLE': '集成',
  'INTEGRATIONS.DASHBOARD.HEADER.ADD_INTEGRATION': '添加集成',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.SEARCH': '未找到搜索词的结果:',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER': '未',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.FILTER.SUFFIX': '找到集成。',
  'INTEGRATIONS.DASHBOARD.EMPTY_STATE.HIDDEN': '没有可用的隐藏集成。',
  'INTEGRATIONS.DASHBOARD.APPLICATIONS_DISCOVERED': '应用程序已发现',
  'INTEGRATIONS.DASHBOARD.OWNER_LABEL': '所有者:',
  'INTEGRATIONS.DASHBOARD.LAST_DISCOVERED': '上次发现时间:',
  'INTEGRATIONS.DASHBOARD.CONNECTION_FAILED': '连接失败',
  'INTEGRATIONS.DASHBOARD.USERS_HAVE_ACCESS': '用户有访问权限',
  'INTEGRATIONS.DASHBOARD.CHIP_DISCOVERY_SOURCE': '发现源',
  'INTEGRATIONS.BUTTON.ENABLE': '启用',
  'INTEGRATIONS.BUTTON.DISABLE': '禁用',
  'INTEGRATIONS.ENABLING': '正在启用',
  'INTEGRATIONS.MODAL_TITLE.DISCOVERY': '发现',
  'INTEGRATIONS.DASHBOARD.REUPLOAD': '重新上传',
  'INTEGRATIONS.DASHBOARD.ONBOARD': '使用',
  'INTEGRATIONS.DASHBOARD.HIDE': '隐藏',
  'INTEGRATIONS.DASHBOARD.UNHIDE': '取消隐藏',
  'INTEGRATIONS.DISCOVERY.TABS_ARIA_LABEL': '发现配置选项卡',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_TITLE': '丢弃未保存的更改?',
  'INTEGRATIONS.DISCOVERY.DISCARD_UNSAVED_CHANGES_SUBTITLE':
    '有未保存的更改。如果继续，更改将丢失。',
  'INTEGRATIONS.BUTTON.DISCARD_CHANGES': '丢弃更改',
  'INTEGRATIONS.BUTTON.CANCEL': '取消',
  'INTEGRATIONS.BUTTON.SAVE_ERROR_TITLE': '保存错误',
  'INTEGRATIONS.CMDB_HEADER.BACK_BUTTON_ARIA_LABEL': '返回到上一页',
  'INTEGRATIONS.CMDB_HEADER.IMAGE_ALT': '应用程序图标',
  'INTEGRATIONS.CMDB_HEADER.RUN_MANUALLY_BUTTON': '手动运行',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_FAILED_TITLE': '禁用失败',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_FAILED_TITLE': '启用失败',
  'INTEGRATIONS.CMDB_HEADER.ALERT.DISABLE_SUCCESS_DESCRIPTION': '已成功禁用。',
  'INTEGRATIONS.CMDB_HEADER.ALERT.ENABLE_SUCCESS_DESCRIPTION': '已成功启用。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT':
    '其他导入当前正在进行。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.JOBCONFLICT.SUBHEADING':
    '其他进程正在导入资产。请稍后重试。',
  'INTEGRATION.DISCOVERY.SETUP.SERVICENOW.IMPORTFAILED': '导入失败',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS': '正在从 ServiceNow 导入资产',
  'INTEGRATIONS.DISCOVERY.IMPORTINGASSETS.MESSAGE':
    '等候时可以退出页面。过程完成后，我们将通知您。',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ROW_ARIA_LABEL':
    '立即添加新属性映射',
  'INTEGRATIONS.ATTRIBUTE_MAPPINGS.BUTTON.ADD_ATTRIBUTE': '添加属性',
  'INTEGRATIONS.ATTRIBUTE_ROW.EMPTY_PLACEHOLDER': '(空)',
  'INTEGRATIONS.ATTRIBUTE_ROW.DELETE_ARIA_LABEL': '删除此映射',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SERVICENOW_FIELD': 'ServiceNow 字段',
  'INTEGRATIONS.ATTRIBUTE_ROW.HEADER.SAVIYNT_FIELD': 'Saviynt 字段',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SERVICENOW': '搜索 ServiceNow 属性',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.SEARCH_SAVIYNT': '搜索 Saviynt 属性',
  'INTEGRATIONS.ATTRIBUTE_DROPDOWN.CUSTOM_SUFFIX': '(自定义)',
  'INTEGRATIONS.ERROR.SAVE_FAILED': '保存失败',
  'INTEGRATIONS.SCHEDULING.ARIA_LABEL': '计划配置',
  'INTEGRATIONS.SCHEDULING.REPEATS_AT': '于 {timeLabel} UTC。',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_TITLE': '重复于',
  'INTEGRATIONS.SCHEDULING.REPEAT_ON_DAYS_GROUP': '重复天数',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.LABEL.REPEAT_EVERY': '重复间隔时间',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.PLACEHOLDER.ENTER_INTERVAL':
    '输入间隔时间',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.ARIA_LABEL.REPEAT_INTERVAL':
    '重复间隔时间 (天数、周数或月数)',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.DAY': '日',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.WEEK': '周',
  'INTEGRATIONS.SCHEDULING_FREQUENCY.UNIT.MONTH': '月',
  'INTEGRATIONS.DAYS.SUN': '周日',
  'INTEGRATIONS.DAYS.MON': '周一',
  'INTEGRATIONS.DAYS.TUE': '周二',
  'INTEGRATIONS.DAYS.WED': '周三',
  'INTEGRATIONS.DAYS.THU': '周四',
  'INTEGRATIONS.DAYS.FRI': '周五',
  'INTEGRATIONS.DAYS.SAT': '周六',
  'INTEGRATIONS.BUTTON.DISABLING': '正在禁用',
  'INTEGRATIONS.BUTTON.SAVED': '已保存',
  'INTEGRATIONS.BUTTON.SAVING': '正在保存',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_TITLE': '是否确定要禁用 ',
  'INTEGRATIONS.DISABLE_MODAL.ALERT_SUBTITLE':
    '禁用发现源将停止资产导入，并且您将无法配置源。',
  'INTEGRATIONS.DISCOVERY.HERE': '此处',
  'INTEGRATIONS.DISCOVERY.EXISTING.CONNECTION.FAILED':
    '您的发现源已成功创建，但与 ServiceNow 的连接失败。要开始导入资产，请在发现源配置页面上更新连接详细信息 ',
};

export default zhCN;
